// src/components/Toast/CustomToast.js
import React from "react";

const AUTO_CLOSE_DURATION = 3000; // 3 seconds

const CustomToast = ({ id, message, type = "info", onClose }) => {
  const toastConfig = {
    success: {
      icon: "✓",
      bg: "#ffffff",
      color: "rgb(21, 87, 36)",
      progress: "rgb(40, 167, 69)",
      border: "1px solid #c3e6cb",
    },
    error: {
      icon: "!",
      bg: "#ffffff",
      color: "rgb(114, 28, 36)",
      progress: "rgb(220, 53, 69)",
      border: "1px solid #f5c6cb",
      fontSize:"10px"
    },
    warning: {
      icon: "!",
      bg: "#ffffff",
      color: "rgb(133, 100, 4)",
      progress: "rgb(255, 193, 7)",
      border: "1px solid #ffeaa7",
    },
    info: {
      icon: "ℹ",
      bg: "#ffffff",
      color: "rgb(12, 84, 96)",
      progress: "rgb(23, 162, 184)",
      border: "1px solid #bee5eb",
    },
  };

  const config = toastConfig[type] || toastConfig.info;

  React.useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, AUTO_CLOSE_DURATION);
    return () => clearTimeout(timer);
  }, [id]);

  const handleClose = () => {
    const el = document.getElementById(`toast-${id}`);
    if (el) {
      el.style.animation = "toastOut 0.35s ease-in forwards";
      setTimeout(() => onClose(id), 350);
    }
  };

  return (
    <div
      id={`toast-${id}`}
      className="custom-react-toastify"
      style={{
        minWidth: "350px",
        background: config.bg,
        color: config.color,
        borderRadius: "8px",
        border: config.border,
        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
        overflow: "hidden",
        animation: "smoothToastIn 0.45s cubic-bezier(0.2, 0.8, 0.2, 1) forwards",
        marginBottom: "10px",
        transformOrigin: "top right",
      }}
      onMouseEnter={(e) => {
        const progress = e.currentTarget.querySelector(".toast-progress");
        if (progress) progress.style.animationPlayState = "paused";
      }}
      onMouseLeave={(e) => {
        const progress = e.currentTarget.querySelector(".toast-progress");
        if (progress) progress.style.animationPlayState = "running";
      }}
    >
      <div style={{ padding: "12px 16px", display: "flex", alignItems: "center" }}>
        <div
          style={{
            fontSize: "22px",
            fontWeight: "bold",
            marginRight: "8px",
            minWidth: "30px",
            textAlign: "center",
          }}
        >
          {config.icon}
        </div>

        <div style={{ flex: 1, fontSize: "14px", fontWeight: "500", lineHeight: "1.4" }}>
          {message}
        </div>

        <button
          onClick={handleClose}
          style={{
            background: "none",
            border: "none",
            fontSize: "40px",
            cursor: "pointer",
            color: config.color,
            opacity: 0.7,
            padding: "4px 8px",
            borderRadius: "4px",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
        >
          X
        </button>
      </div>

      <div style={{ height: "4px", backgroundColor: "rgba(0,0,0,0.08)" }}>
        <div
          className="toast-progress"
          style={{
            height: "100%",
            backgroundColor: config.progress,
            width: "100%",
            animation: `progress ${AUTO_CLOSE_DURATION / 1000}s linear forwards`,
          }}
        />
      </div>
    </div>
  );
};

// Smoother animations - more natural & modern
if (!window.toastCssInjected) {
  const style = document.createElement("style");
  style.textContent = `
    @keyframes smoothToastIn {
      from {
        opacity: 0;
        transform: translateX(50px) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateX(0) scale(1);
      }
    }
    @keyframes toastOut {
      from {
        opacity: 1;
        transform: translateX(0) scale(1);
      }
      to {
        opacity: 0;
        transform: translateX(50px) scale(0.95);
        margin: 0;
        padding: 0;
        height: 0;
      }
    }
    @keyframes progress {
      from { width: 100%; }
      to { width: 0%; }
    }
  `;
  document.head.appendChild(style);
  window.toastCssInjected = true;
}

export default CustomToast;